
import 'instantsearch.css/themes/satellite.css'
import { instantMeiliSearch } from '@meilisearch/instant-meilisearch'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import { db, analytics } from '~/plugins/firebase'
import { logEvent } from 'firebase/analytics'
import { doc, getDoc } from 'firebase/firestore'
import { updateFirestoreDoc } from '../api'
import { debounce } from '../utils/debounce'

export default {
  computed: {
    ...mapState({
      authUser: (state) => state.authUser,
    }),
    ...mapGetters([
      'isLoggedIn',
      'emailVerified',
      'isAdmin',
      'isGraduate',
      'isIndustry',
      'allSchools',
      'graduateSchools',
      'regions',
      'schoolById',
    ]),
  },
  async mounted() {
    if (!this.graduateSchools.length) {
      await this.getSchools()
    }
    this.getLikes()
  },
  data() {
    return {
      loading: true,
      likes: [],
      infiniteId: +new Date(),
      initialUiState: {
        ['graduates:year:desc']: {
          refinementList: {
            public: ['true'],
          },
        },
      },
      searchClient: instantMeiliSearch(
        'https://meilisearch.beardsley.com.au',
        '72d8212e92c05fa6492bd738183a97c7d82dfe651a363074df406087471a0ec6',
        {
          finitePagination: true,
        }
      ),
    }
  },
  methods: {
    ...mapMutations(['SHOW_MESSAGE']),
    ...mapActions(['getSchools']),
    infiniteScroll($event, isLastPage, refineNext) {
      debounce(() => {
        if (isLastPage) {
          $event.complete()
        } else {
          $event.loaded()
          refineNext()
        }
      }, 3000)()
    },
    transformItems(items) {
      return items.map((item) => ({
        ...item,
        label: this.schoolById(item.label)?.name,
      }))
    },
    async toggleLike(item) {
      const list = this.likes.find((o) => o.name == item.name)
      const index = list.ids.indexOf(item.id)
      if (index > -1) {
        list.ids.splice(index, 1)
      } else {
        list.ids.push(item.id)
      }
      const [error] = await updateFirestoreDoc('users', this.authUser.uid, {
        likes: this.likes,
      })
      if (error) this.SHOW_MESSAGE({ content: error.message, color: 'error' })
      logEvent(analytics, 'like', {
        item_id: item.id,
        list_name: item.name,
      })
    },
    async getLikes() {
      if (!this.isLoggedIn) return
      try {
        const docSnap = await getDoc(doc(db, 'users', this.authUser.uid))
        const data = docSnap.data()
        if (data.likes) {
          this.likes = data.likes
        }
      } catch (error) {
        // Error
      }
    },
  },
}
